import { NotificationsScreen } from '@/components/domain/notifications/NotificationsScreen';

export default function Notifications() {
  return <NotificationsScreen />;
}
